// extracted by mini-css-extract-plugin
export default {"haveAccountSign":"Activation_haveAccountSign__Qc0kc","header":"Activation_header__0jvy+","login":"Activation_login__QXzyW"};